import { render, staticRenderFns } from "./CustomerCreate.vue?vue&type=template&id=0c1a7440"
import script from "./CustomerCreate.vue?vue&type=script&lang=ts"
export * from "./CustomerCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports